import React from 'react';
import { PDFDownloadLink } from '@react-pdf/renderer';

import { Appointment } from '~weekly-planner/lib/common';

import { ClickableIcon } from '~components';
import { faFilePdf, faSpinner } from '~components/icon';

import useGeneratePdf from '~appointments/forms/appointment/pdf-export/single';

interface ComponentProps {
  appointment: Appointment | null;
  logo: string;
  company?: any;
  color?: string;
}

export const ExportToPDFButton: React.FC<ComponentProps> = ({ appointment, logo, company, color }) => {
  const pdfDocument = useGeneratePdf({ appointment, logo, company });
  const {
    client: { full_name },
    id,
  } = appointment ?? { client: {} };
  const name = full_name?.toLocaleLowerCase().trim().replaceAll(' ', '-');
  const iconColor = color ?? 'black';

  return (
    <PDFDownloadLink document={pdfDocument} fileName={`appointment-${id}-${name}.pdf`}>
      {({ loading }) =>
        loading ? (
          <ClickableIcon
            id="Loading-Export"
            toolTip="Loading document..."
            icon={faSpinner}
            color={iconColor}
            iconClassname="spin"
          />
        ) : (
          <ClickableIcon id="Loading-Export" toolTip="Export To PDF" icon={faFilePdf} color={iconColor} />
        )
      }
    </PDFDownloadLink>
  );
};

export default ExportToPDFButton;
